import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent } from '../../../tms-shared';
import { StockCardData } from '../../models';

@Component({
  selector: 'app-stock-card-renderer',
  templateUrl: './stock-card-renderer.component.html',
  styleUrl: './stock-card-renderer.component.scss',
})
export class StockCardRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  get data(): StockCardData {
    return this.rowData;
  }

  get formattedBalance(): string {
    const value = this.data?.balance != null ? this.data.balance.toFixed(2) : '0.00';
    const uom = this.data?.uom;
    return uom ? `${value} ${uom}` : value;
  }

  get printMode(): boolean {
    return this.params?.printMode ?? false;
  }

  get isSelected(): boolean {
    const selectedStockNos: Set<string> = this.params?.selectedStockNos;
    return selectedStockNos?.has(this.data?.stockNo) ?? false;
  }

  onCardClick() {
    if (!this.printMode) return;
    const onToggle = this.params?.onToggle;
    if (onToggle) {
      onToggle(this.data.stockNo);
    }
  }
}
